module.exports = __webpack_public_path__ + "static/media/kai.9180dc22.png";